import React from "react";
import { ReactComponent as FileIcon } from "../../../../assets/Icons/Setting/Profile/FileIcon.svg";
const DocumentFile = ({ folderName, onDoubleClick }) => {
  return (
    <button
      type="button"
      className="adminProfileDocumentFile"
      onDoubleClick={onDoubleClick}
    >
      <FileIcon fill="white" />

      <span className=" w-full t-12 poppins-medium text-align-left absolute bottom-0 mb-1 text-align-center">
        {folderName}
      </span>
    </button>
  );
};

export default DocumentFile;
